import { render } from "./cotar-frete-list-interna.vue?vue&type=template&id=53927c13"
import script from "./cotar-frete-list-interna.vue?vue&type=script&lang=js"
export * from "./cotar-frete-list-interna.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__